// frontend/src/api/axios.ts
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  console.log('[OUT]', (config.method || '').toUpperCase(), `${config.baseURL}${config.url}`, 'Auth:', !!token);
  return config;
});

// Завершение сделки без нужного остатка на складе — показываем окно со списком позиций (слушает App)
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const data = error?.response?.data;
    if (data?.code === 'INSUFFICIENT_STOCK' && Array.isArray(data.shortages)) {
      window.dispatchEvent(new CustomEvent('stock-shortage', { detail: data.shortages }));
    }
    if (data?.code === 'SERIALS_REQUIRED') {
      window.alert(data.message);
    }
    return Promise.reject(error);
  },
);

export default api;
